import { Component, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { paymentI } from 'app/core/interfaces/payment';
import { PaymentSettings } from 'app/core/interfaces/payment-settings';
import { PaymentSettingsService } from 'app/core/http/services/payment-settings.service';
import { DialogService } from 'app/services/dialog.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';

@Component({
  selector: 'page-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent extends BaseComponent implements OnInit {
  public methods: paymentI[] = [];
  public title = 'Formas de pagamento';
  public paymentForm: FormGroup;
  public paymentSettings!: PaymentSettings;
  public mainPercentage = 0;

  public get methodActive(): paymentI[] {
    const methods = [...this.methods];
    return methods.filter((item: paymentI) => item.active);
  }

  public get methodInactive(): paymentI[] {
    const methods = [...this.methods];
    return methods.filter((item: paymentI) => !item.active);
  }

  constructor(
    private fb: FormBuilder,
    private paymentSettingsService: PaymentSettingsService,
    private dialogService: DialogService,
    injector: Injector,
  ) {
    super(injector);
    this.paymentForm = this.fb.group({
      secretary_commission_percentage: [null, [Validators.required, Validators.min(0), Validators.max(99), Validators.pattern(/^\d+$/)]],
    });
    this.paymentForm.get('secretary_commission_percentage')?.valueChanges.subscribe(() => this.deriveMainPercentage());
  }

  ngOnInit(): void {
    this.getPaymentMethods();
    this.loadPaymentSettings();
  }

  getPaymentMethods() {
    this.methods = this.auth.getFromLocalStorage('paymentMethods');
  }

  loadPaymentSettings() {
    const organizationId = this.getUserLogged().id;
    this.paymentSettingsService.findByOrganization(organizationId).subscribe((settings) => {
      this.paymentSettings = settings;
      this.paymentForm.patchValue({
        secretary_commission_percentage: settings.secretary_commission_percentage,
      });
      this.deriveMainPercentage();
    });
  }

  deriveMainPercentage() {
    const commission = this.paymentForm.get('secretary_commission_percentage')?.value || 0;
    this.mainPercentage = 100 - commission;
  }

  savePaymentSettings() {
    if (this.paymentForm.invalid) {
      return;
    }

    const settings: PaymentSettings = {
      ...this.paymentSettings,
      organization_id: this.getUserLogged().id,
      secretary_commission_percentage: this.paymentForm.get('secretary_commission_percentage')?.value,
    };

    if (this.paymentSettings?.payment_settings_id) {
      this.paymentSettingsService
        .update(settings, this.paymentSettings.payment_settings_id)
        .subscribe(() => this.openSnackBar('Configurações salvas com sucesso', 'success'));
    } else {
      this.paymentSettingsService.create(settings).subscribe(() => {
        this.openSnackBar('Configurações salvas com sucesso', 'success');
        this.loadPaymentSettings();
      });
    }
  }

  openPaymentMethodDetail(method: paymentI) {
    const data = {
      title: method.name,
      param: { method },
    };

    this.dialogService.openComponentDialog(PaymentDetailsComponent, data);
  }
}
